import React from "react";
import TableActionButtons from '../../components/CommonComponents/TableActionButtons';
import EmptyState from '../../components/CommonComponents/EmptyState';
import { Package } from 'lucide-react';
import { tableContainer, tableBase, tableHead, tableHeader, tableCell, tableRow } from '../../utils/tableStyle';
// ...existing code...

export default function BranchTable({ branches, onEdit, onDelete, onToggle, onViewDetails }) {
  return (
    <div className={tableContainer}>
      <table className={tableBase}>
        <thead className={tableHead} style={{ background: 'var(--color-primary)' }}>
          <tr>
            <th className={tableHeader + ' text-left'}>Name</th>
            <th className={tableHeader + ' text-left'}>Customer</th>
            <th className={tableHeader + ' text-left'}>Location</th>
            <th className={tableHeader + ' text-left'}>Status</th>
            <th className={tableHeader + ' text-center'}>Details</th>
            <th className={tableHeader + ' text-center'}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {branches.length === 0 ? (
            <tr>
              <td colSpan={6} className={tableCell + ' text-center py-8'}>
                <div className="flex flex-col items-center justify-center">
                  <EmptyState icon={Package} message="No branches found." size="default" />
                </div>
              </td>
            </tr>
          ) : (
            branches.map((b) => (
              <tr key={b.id} className={tableRow + ' border-b last:border-0'}>
                <td className={tableCell + ' text-left'}>{b.name}</td>
                <td className={tableCell + ' text-left'}>{b.customer?.name || <span className="text-gray-400">-</span>}</td>
                <td className={tableCell + ' text-left'}>{b.location || <span className="text-gray-400">-</span>}</td>
                <td className={tableCell + ' text-left'}>
                  <span className={`px-2 py-1 rounded text-xs font-medium ${b.status === "ACTIVE" ? "bg-green-100 text-green-700" : "bg-gray-200 text-gray-500"}`}>{b.status}</span>
                </td>
                <td className={tableCell + ' text-center'}>
                  <button
                    className="text-blue-600 hover:underline font-medium"
                    onClick={() => onViewDetails && onViewDetails(b)}
                  >
                    View
                  </button>
                </td>
                <td className="px-3 py-2 text-center align-middle">
                  <div className="flex flex-col md:flex-row items-center justify-center gap-2">
                    <TableActionButtons
                      canEdit={true}
                      canDelete={true}
                      canToggle={true}
                      toggleStatus={b.status}
                      onEdit={() => onEdit(b)}
                      onDelete={() => onDelete(b)}
                      onToggle={() => onToggle(b)}
                    />
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
